import { OrderPredictionItem } from '@/models/OrderPredictionItem';

export type OrderPredictionAlgorithm = 'simple_reorder';

export interface OrderPrediction {
  id: string;
  date: Date;
  storeId: string;
  targetDate?: Date;
  deliveryDate?: Date;
  historyEndDate?: Date;
  items: OrderPredictionItem[];
}

export interface OrderPredictionStatus {
  available: boolean;
}

export const formatOrderPredictionAlgorithm = (algorithm?: OrderPredictionAlgorithm): string => {
  switch (algorithm) {
    case 'simple_reorder':
      return 'Simple reorder';
    default:
      return '';
  }
};
